// import PropTypes from 'prop-types';
import Field from '@scandipwa/scandipwa/src/component/Field';
import PropTypes from 'prop-types';
import { FieldType } from '@scandipwa/scandipwa/src/component/Field/Field.config';
import { showNotification } from '@scandipwa/scandipwa/src/store/Notification/Notification.action';
import { NotificationType } from '@scandipwa/scandipwa/src/store/Notification/Notification.type';
import { fetchQuery } from '@scandipwa/scandipwa/src/util/Request/Query';
import { ValidationInputType } from '@scandipwa/scandipwa/src/util/Validator/Config';
import OrderTrackQuery from 'Query/OrderTrack.query';
import React, { PureComponent } from 'react';
import './OrderTrack.style';
import { GQLCurrencyEnum } from '@scandipwa/scandipwa/src/type/Graphql.type';
import { getCurrencySymbol } from 'simple-currency-format';

export class OrderTrack extends PureComponent {
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            order_id: "",
            email: "",
            errorMessage: "",
            isloading: false,
            ordertrackdata: []
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.changeOrderInfo = this.changeOrderInfo.bind(this);
    }

    async handleSubmit() {
        this.setState({
            isloading: true
        });

        try {
            const response = await fetchQuery(OrderTrackQuery.getQuery(this.state));
            this.setState({
                errorMessage: "",
                isloading: false,
                ordertrackdata: response?.OrderTrack
            });
        } catch (e) {
            if (e?.length > 0) {
                this.setState({
                    errorMessage: e[0]?.message,
                    isloading: false
                })
            }
        }
    }

    changeOrderInfo(e) {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    }

    renderCustmizeProduct = (data, i) => {
        return (
            <>
                <div className='OrderTrack-Product' key={i}>
                    <img src={data?.ring_setting_image} />
                    <div className='OrderTrack-ProductDescription'>
                        <h5 className='OrderTrack-ProductName'>{data?.setting_name}</h5>
                        <span className='OrderTrack-ProductSKU'>SKU: #{data?.ring_setting_sku}</span>
                        <span className='OrderTrack-ProductQTY'>QTY: 1</span>
                        <div className='OrderTrack-Prices'>
                            <del className='OrderTrack-OriginalPrices'>{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(data?.original_price)}</del>
                            <span className='OrderTrack-DiscoountPrices'>{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(data?.discount_price)}</span>
                        </div>
                    </div>
                </div>
                <div className='OrderTrack-Product' key={i}>
                    <img src={data?.diamond_image} />
                    <div className='OrderTrack-ProductDescription'>
                        <h5 className='OrderTrack-ProductName'>{data?.diamond_name}</h5>
                        <span className='OrderTrack-ProductSKU'>SKU: #{data?.diamond_sku}</span>
                        <div className='OrderTrack-Prices'>
                            <span className='OrderTrack-DiscoountPrices'>{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(data?.diamond_price)}</span>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    renderSimpoleProduct = (data, i) => {
        return (
            <div className='OrderTrack-Product' key={i}>
                <img src={data?.product_image} />
                <div className='OrderTrack-ProductDescription'>
                    <h5 className='OrderTrack-ProductName'>{data?.name}</h5>
                    <span className='OrderTrack-ProductSKU'>SKU: #{data?.product_sku}</span>
                    <span className='OrderTrack-ProductQTY'>QTY: {data?.qty}</span>
                    <div className='OrderTrack-Prices'>
                        <del className='OrderTrack-OriginalPrices'>{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(data?.original_price * data?.qty)}</del>
                        <span className='OrderTrack-DiscoountPrices'>
                            {
                                data?.name?.includes("FREE - ") ? <span className='Frree-Gift-Price'>Free</span> : <>
                                    {getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(data?.discount_price * data?.qty)}
                                </>
                            }
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    renderOrderAdressInfo = (value) => {
        const shipping_address = JSON.parse(value.shipping_address);
        const billing_address = JSON.parse(value.billing_address);

        return (
            <div className='OrderTrack-OrderInfo'>
                <div className='OrderTrack-OrderAdressData'>
                    <span className='OrderTrack-Title'>shipping address</span>
                    {
                        shipping_address?.map((value, index) => (
                            <div className='OrderTrack-ShippingAdress' key={index}>
                                {value?.shipping_street?.map((value, index) => (
                                    <span key={index}>{value}</span>
                                ))}
                                <span>{value?.shipping_city}, {value?.shipping_region}, {value?.shipping_country}</span>
                                <span>{value?.shipping_postcode}</span>
                            </div>
                        ))
                    }
                </div>
                <div className='OrderTrack-OrderAdressData'>
                    <span className='OrderTrack-Title'>billing address</span>
                    {
                        billing_address?.map((value, index) => (
                            <div className='OrderTrack-ShippingAdress' key={index}>
                                {value?.billing_street?.map((value, index) => (
                                    <span key={index}>{value}</span>
                                ))}
                                <span>{value?.billing_city}, {value?.billing_region}, {value?.billing_country}</span>
                                <span>{value?.billing_postcode}</span>
                            </div>
                        ))
                    }
                </div>
                <div className='OrderTrack-OrderAdressData'>
                    <span className='OrderTrack-Title'>shipping method</span>
                    <div className='OrderTrack-ShippingAdress'>
                        <span>{value?.shipping_description}</span>
                    </div>
                </div>
                <div className='OrderTrack-OrderAdressData'>
                    <span className='OrderTrack-Title'>payment method</span>
                    <div className='OrderTrack-ShippingAdress'>
                        <span>{value?.payment_method}</span>
                    </div>
                </div>
            </div>
        )
    }

    renderOrderSummery = (value) => {
        const simple_product = JSON.parse(value.simple_product);
        const customize_product = JSON.parse(value.customize_product);

        let price = 0;
        let product_discount_price = 0;
        let giftproduct_price = 0;

        if (simple_product?.length > 0) {
            const data = simple_product?.map((value) => {
                value?.length > 0 && value?.map((data, i) => {
                    if (data?.name?.includes("FREE - ")) {
                        giftproduct_price += Number(data?.discount_price) * data?.qty;
                    }
                });
            });
        }

        if (simple_product?.length > 0) {
            const data = simple_product?.map((value) => {
                value?.length > 0 && value?.map((data, i) => {
                    if (!data?.name?.includes("FREE - ")) {
                        price += Number(data?.original_price) * data?.qty;
                        product_discount_price += Number(data?.discount_price) * data?.qty;
                    }
                });
            });
        }

        if (customize_product?.length > 0) {
            const data = customize_product?.map((value) => {
                value?.length > 0 && value?.map((data, i) => (
                    price += Number(data?.original_price),
                    product_discount_price += Number(data?.discount_price),
                    product_discount_price += Number(data?.diamond_price),
                    price += Number(data?.diamond_price)
                ));
            });
        }

        const promotionsavingoffers = price - product_discount_price;
        const couponcodediscount = Number(value?.discount) + giftproduct_price;
        const subtotal = price - promotionsavingoffers + couponcodediscount;

        return (
            <div className='OrderTrack-OrderSummery'>
                <div className="OrderTrack-SummaryItem ">
                    <p className="OrderTrack-Text">order Total</p>
                    <span className="OrderTrack-Price  ">{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(price)}</span>
                </div>
                <div className="OrderTrack-SummaryItem ">
                    <p className="OrderTrack-Text">promotion saving offers</p>
                    <span className="OrderTrack-Price  ">
                        -{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(promotionsavingoffers)}
                    </span>
                </div>
                <div className="OrderTrack-SummaryItem ">
                    <p className="OrderTrack-Text">coupon code discount</p>
                    <span className="OrderTrack-Price  ">
                        -{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.abs(Math.round(couponcodediscount))}
                    </span>
                </div>
                <div className="OrderTrack-SummaryItem ">
                    <p className="OrderTrack-Text">Sub Total</p>
                    <span className="OrderTrack-Price  ">{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(subtotal)}</span>
                </div>
                <div className="OrderTrack-SummaryItem ">
                    <p className="OrderTrack-Text">shipping</p>
                    <span className="OrderTrack-Price  ">{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(value?.shipping_amount)}</span>
                </div>
                <div className="OrderTrack-SummaryItem ">
                    <p className="OrderTrack-Text">tax</p>
                    <span className="OrderTrack-Price  ">{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(value?.tax)}</span>
                </div>
                <div className="OrderTrack-SummaryItem ">
                    <p className="OrderTrack-Text">Total Paid</p>
                    <span className="OrderTrack-Price  ">{getCurrencySymbol(GQLCurrencyEnum.USD)}{Math.round(value?.grand_total)}</span>
                </div>
            </div>
        )
    }

    renderOrderTrackData = (value) => {
        const simple_product = JSON.parse(value.simple_product);
        const customize_product = JSON.parse(value.customize_product);

        return (
            <>
                <h4 className='OrderTrack-OrderNumber'>order number: <span>#{value?.order_id}</span></h4>
                <div className='OrderTrack-CustomerInfo'>
                    <p>{value?.customer_name}</p>
                    <p>{value?.customer_email}</p>
                    <h4 className='OrderTrack-OrderStatus'>order status: <span>{value?.order_status}</span></h4>
                </div>
                {this.renderOrderAdressInfo(value)}
                <div className='OrderTrack-ProductInfo'>
                    {
                        customize_product?.length > 0 && customize_product?.map((value, index) => (
                            value?.length > 0 && value?.map((data, i) => (
                                this.renderCustmizeProduct(data, i)
                            ))
                        ))
                    }
                    {
                        simple_product?.length > 0 && simple_product?.map((value, index) => (
                            value?.length > 0 && value?.map((data, i) => (
                                this.renderSimpoleProduct(data, i)
                            ))
                        ))
                    }
                    {this.renderOrderSummery(value)}
                </div>
                { }
            </>
        )
    }

    render() {
        const { order_id, email, errorMessage, isloading, ordertrackdata } = this.state

        return (
            <div className='ContentWrapper'>
                <div className="OrderTrack">
                    {
                        ordertrackdata?.length > 0 ? ordertrackdata?.map((value, index) => (
                            <div className='OrderTrack-Data' key={index}>
                                {this.renderOrderTrackData(value)}
                            </div>
                        )) : <>
                            <div className='OrderTrack-PageInfotmation'>
                                <h1 className='OrderTrack-PageTitle'>track your order</h1>
                                <p className='OrderTrack-PageDescription'>To view your order, enter your email address and order number below. You will be provided with your expected delivery date and tracking number if it has been generated.</p>
                            </div>
                            <div className='OrderTrack-Form'>
                                {errorMessage && <span className='OrderTrack-Error'>{errorMessage}</span>}
                                <Field
                                    type={FieldType.NUMBER}
                                    attr={{
                                        id: 'order_id',
                                        name: 'order_id',
                                        defaultValue: order_id,
                                        placeholder: 'Your order number',
                                        autoComplete: 'order_id',
                                    }}
                                    validateOn={['onChange']}
                                    validationRule={{
                                        isRequired: true,
                                        inputType: ValidationInputType.NUMERIC,
                                    }}
                                    addRequiredTag
                                    events={{
                                        onChange: this.changeOrderInfo,
                                    }}
                                />
                                <Field
                                    type={FieldType.EMAIL}
                                    attr={{
                                        id: 'email',
                                        name: 'email',
                                        defaultValue: email,
                                        placeholder: 'Your email name',
                                        autoComplete: 'email',
                                    }}
                                    validateOn={['onChange']}
                                    validationRule={{
                                        isRequired: true,
                                        inputType: ValidationInputType.EMAIL,
                                    }}
                                    addRequiredTag
                                    events={{
                                        onChange: this.changeOrderInfo,
                                    }}
                                />
                                <div className='OrderTrack-ButtonWrapper'>
                                    <button
                                        className='OrderTrack-Button'
                                        onClick={this.handleSubmit}
                                        disabled={isloading}
                                    >
                                        <span>track order</span>
                                    </button>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        );
    }
}

export default OrderTrack;
